import { defineComponent, ref, watch } from "vue";
import elDragDialog from "@com/directive/el-drag-dialog";
import { t } from "@/lang";
export default defineComponent({
    components: {},
    props: {
        visible: {
            type: Boolean
        }
    },
    directives: {
        elDragDialog: elDragDialog
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var title = t("playTurbo.whole.plPoint.list.title");
        var dialogVisible = ref(false);
        var dialogConfig = {
            modal: false,
            top: "0"
        };
        var eventDialogTitle = "";
        watch(function() {
            return props.visible;
        }, function(val) {
            dialogVisible.value = val;
        });
        watch(function() {
            return dialogVisible.value;
        }, function(val) {
            emit("update:visible", dialogVisible.value);
        });
        return {
            title: title,
            dialogVisible: dialogVisible,
            dialogConfig: dialogConfig,
            eventDialogTitle: eventDialogTitle
        };
    }
});
